import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default class SearchForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            status: '',
            work_start_date: null,
            work_end_date: null,
            categories_name:null,
            page: 1
        }
        this.handleChangeWorkStartDateCreated = this.handleChangeWorkStartDateCreated.bind(this);
        this.handleChangeWorkEndDateCreated = this.handleChangeWorkEndDateCreated.bind(this);
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSearchData = this.handleSearchData.bind(this);
        this.resetInputField = this.resetInputField.bind(this);
    }

    /**
     * Call search data by text
     */
    handleSearchData() {
        const searchForm = {
            status: this.state.status,
            work_start_date: this.state.work_start_date ? this.state.work_start_date.format("YYYY-MM-DD") : '',
            work_end_date: this.state.work_end_date ? this.state.work_end_date.format("YYYY-MM-DD") : '',
            categories_name: this.state.categories_name ? this.state.categories_name : '',
            page: 1
        };
        if (typeof this.props.onSearch === 'function') {
            this.props.onSearch(searchForm);
        }
    }

    /**
     * Process change date create at
     */
    handleChangeWorkStartDateCreated(date) {
        this.setState({
          work_start_date: date,
        });
    }

    /**
     * Process change date create at
     */
    handleChangeWorkEndDateCreated(date) {
        this.setState({
          work_end_date: date,
        });
    }

    /**
     * Process field change
     */
    handleFieldChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    /**
     * Clear data input field
     */
    resetInputField() {
        this.setState({
            status: '',
            work_start_date: null,
            work_end_date: null,
            categories_name:null,
        });
    }

    render() {
        return(
            <div className="collapse multi-collapse" id="search_order">
                <div className="card mt-3">
                    <div className="card-header">依頼を検索する条件</div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-sm-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="">ステータス</label>
                                        <select className="form-control" name="status" value={this.state.status} onChange={this.handleFieldChange}>
                                            <option value="all">すべて</option>
                                            <option value="NULL">掲載確認</option>
                                            <option value="1">掲載中</option>
                                            <option value="2">掲載終了</option>
                                            <option value="3">就業中</option>
                                            <option value="4">評価待ち</option>
                                            <option value="5">作業完了</option>
                                            <option value="6">未採用</option>
                                            <option value="7">仲裁</option>
                                            <option value="8">欠勤</option>
                                            <option value="9">依頼キャンセル</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="">勤務開始日</label>
                                        <div className="input-group">
                                            <DatePicker
                                                locale="ja-JP"
                                                className="form-control form_datepicker"
                                                dateFormat="YYYY/MM/DD"
                                                selected={this.state.work_start_date}
                                                onChange={this.handleChangeWorkStartDateCreated}
                                                placeholderText="勤務開始日"
                                                disabledKeyboardNavigation
                                            />
                                            <div className="input-group-append">
                                                <button className="btn btn-outline-secondary d-none" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="">勤務終了日</label>
                                        <div className="input-group">
                                            <DatePicker
                                                locale="ja-JP"
                                                className="form-control form_datepicker"
                                                dateFormat="YYYY/MM/DD"
                                            selected={this.state.work_end_date}
                                                onChange={this.handleChangeWorkEndDateCreated}
                                                placeholderText="勤務終了"
                                                disabledKeyboardNavigation
                                            />
                                            <div className="input-group-append">
                                                <button className="btn btn-outline-secondary d-none" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="">依頼名</label>
                                        <input type="text" name="categories_name" onChange={this.handleFieldChange} value={this.state.categories_name} className="form-control" placeholder="依頼名"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-footer text-center">
                            <button type="reset" onClick={this.resetInputField} className="btn btn-light">リセット</button>
                            <button type="submit" onClick={this.handleSearchData} className="btn btn-secondary">検索する</button>
                        </div>
                </div>
            </div>
        );
    }
}
